import {
  BusinessOverviewMetric,
  BusinessOverviewPeriod,
} from '@client/graphql/__generated__/types';

export const TAB_DATA_MAP: Record<
  BusinessOverviewMetric,
  { id: string; label: string; isComingSoon?: boolean }
> = {
  [BusinessOverviewMetric.OFFERS_OUT]: {
    id: BusinessOverviewMetric.OFFERS_OUT,
    label: 'Offers Out',
  },
  [BusinessOverviewMetric.OFFERS_ACCEPTED]: {
    id: BusinessOverviewMetric.OFFERS_ACCEPTED,
    label: 'Offers Accepted',
  },
  [BusinessOverviewMetric.OFFER_SCORECARDS]: {
    id: BusinessOverviewMetric.OFFER_SCORECARDS,
    label: 'Offer Scorecards',
  },
  [BusinessOverviewMetric.SIGNED_AGENCY_AGREEMENTS]: {
    id: BusinessOverviewMetric.SIGNED_AGENCY_AGREEMENTS,
    label: 'Agency Agreements',
    isComingSoon: true,
  },
  [BusinessOverviewMetric.OFFERS_CLOSED]: {
    id: BusinessOverviewMetric.OFFERS_CLOSED,
    label: 'Offers Closed',
    isComingSoon: true,
  },
};

export const TABS_LIST = Object.keys(TAB_DATA_MAP) as BusinessOverviewMetric[];

export interface DateRangeOptionType {
  label: string;
  value: BusinessOverviewPeriod;
}

export const DATE_RANGE_OPTIONS: DateRangeOptionType[] = [
  {
    label: 'This Week',
    value: BusinessOverviewPeriod.THIS_WEEK,
  },
  {
    label: 'This Month',
    value: BusinessOverviewPeriod.THIS_MONTH,
  },
];
